.row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.arrow {
  background: var(--panel);
  border: 1px solid var(--border);
  border-radius: 8px;
  width: 2rem;
  height: 2rem;
  font-size: 1.25rem;
  display: grid;
  place-items: center;
  color: var(--text);
}

.arrow:hover:not(:disabled) {
  background: var(--bg);
}

.arrow:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.date {
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 0.4rem 0.6rem;
  background: var(--panel);
  color: var(--text);
  font-size: 0.95rem;
}

.label {
  color: var(--muted);
  font-size: 0.95rem;
  margin-left: 0.25rem;
}

.todayBtn {
  margin-left: auto;
  background: none;
  border: 1px solid var(--border);
  border-radius: 999px;
  padding: 0.3rem 0.85rem;
  font-size: 0.85rem;
  color: var(--muted);
}

.todayBtn:hover {
  color: var(--text);
}
